<template>
    <ul class="space-y-4 mb-6" v-if="resources.length">
        <li class="flex items-start" v-for="resource in resources">
            <div
                :class="settings.is_sourcing_mode ? 'text-sm' : 'text-base'"
            >
                <h5 v-if="resource.vendors && resource.vendors.length" class="type-secondary flex items-center gap-2">
                    {{ resource.vendors[0].display_name }}
                    <span v-if="DateTime.now().diff(DateTime.fromISO(resource.created_at), 'days').days <= 7" class="bg-green/10 inline-block leading-none px-2 py-1 rounded-lg text-green text-[10px] uppercase" aria-hidden="true">New</span>
                </h5>
                <button
                    @click.stop.prevent="getResource($event, resource)"
                    class="block text-left underline-offset-4 hover:underline hover:decoration-solid decoration-1 font-medium leading-tight"
                >
                    {{ resource.name }}
                </button>
                <div class="text-sm type-tertiary capitalize" v-if="resource.created_at">
                    {{ DateTime.fromISO(resource.created_at).toLocaleString(DateTime.DATE) }}
                </div>
            </div>
        </li>
    </ul>
</template>

<script setup>
import {DateTime} from 'luxon';
import {useResources} from "@/Composables";
import {useUser} from "@/Composables";

const {getResource} = useResources();
const {settings} = useUser();
const props = defineProps(['resources']);
</script>
